import script from "./BrowserPrint.vue?vue&type=script&lang=js"
export * from "./BrowserPrint.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__